import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import Layout from "components/Layout";

import { routes } from "routes.js";

let location = "";

const App = () => {
	const [loading, setLoading] = useState(false);
	location = useLocation();

	//setto scroll pagina a 0 quando viene cambiata route
	useEffect(() => {
		document.documentElement.scrollTop = 0;
		document.scrollingElement.scrollTop = 0;
	}, [location]);

	const getRoutes = (routes) =>
		routes.map((route) => {
			if ("collapse" in route) {
				getRoutes(route.collapse);
			}

			if (route.route != undefined)
				return (
					<Route
						exact
						path={route.route}
						element={route.component}
						key={route.key}></Route>
				);
			else return;
		});

	const currentRoute =
		routes.find((route) => route.route === location.pathname) || {};

	const {
		pageTitle = "Rabarbaro | Ristorante e Bar a Piacenza – Tra Lavaggi e Bouquet",
		pageDescription = "A Piacenza, un ristorante nato da una lavanderia e un bar cresciuto tra i fiori. Scegli da che parte entrare: mangi o bevi? O entrambi?",
	} = currentRoute;

	return (
		<>
			<Routes>
				<Route
					path="/"
					element={<Layout title={pageTitle} description={pageDescription} />}>
					<Route path="/" element={<Navigate to="/home" />} />

					{getRoutes(routes)}
				</Route>
			</Routes>
		</>
	);
};

export default App;
